import PropTypes from 'prop-types';

import { CustomContainer } from "components/atoms/DependencyHelper";

import styles from "./ApplicationTypeSelector.module.scss";
import {imagePrefix} from "utils/helperServices";
const ApplicationTypeSelector = (props) => {
  const selected = props.buyOptionSelected.title

  return (
    <>
      <CustomContainer className="d-lg-block">
        <div className={`${styles["pill-btn-all"]}`}>
          { props.buyOptions?.filter(option => option.title !== 'add_contract')
          .map((option, index) => (
            <div key={index}
              onClick={() => props.handleSelectedBuyOption(option)}
              className={`d-flex align-items-center 
                ${selected === option.title
                  ? `${styles["btn-gradient"]}`
                  : `${styles["default-gradient"]}`
                }
              `}
            >
              <div className={`${styles["pill-btn"]}`}>
                <input
                  type="radio"
                  name="contract-type"
                  checked={selected === option.title}
                  id={`contract-type-${index}`}
                  className="mr-s"
                  readOnly
                />

                <label htmlFor={`contract-type-${index}`}>
                  {option?.title === "Get this deal on a new contract" ? "New Contract" : option?.title}
                  {selected === option.title && 
                    <img
                      className={styles["PillVectorPrice_icon"]}
                      src={`${imagePrefix}/assets/images/pillvector.svg`}
                    />
                  }
                </label>
              </div>
            </div>
          ))}
        </div>
      </CustomContainer>
    </>
  );
}

const BuyOptionProps = PropTypes.shape({
  option_type_id: PropTypes.number,
  price_type: PropTypes.string,
  sku: PropTypes.string,
  title: PropTypes.string,
})

ApplicationTypeSelector.propTypes = {
  buyOptions: PropTypes.arrayOf(BuyOptionProps),
  buyOptionSelected: BuyOptionProps,
  handleSelectedBuyOption: PropTypes.func,
}

export default ApplicationTypeSelector;
